import React, { Component, createRef } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { SHA256 } from 'crypto-js';

import { getContent } from '../../../util/responseUtil';
import API_AUTHENTICATION from '../../../api/apiAuthentication';
import API_TNC from '../../../api/apiTNC';
import IconGroChat from '../../../assets/icons/IconGroChat';
import OutsideLogo from '../../../components/Common/OutsideLogo';
import { redirectUri } from '../../../util/redirectUtil';
import { baseUrl, grochatPwaUrl, localUrl } from '../../../config/serviceConfig';
import { GroChatVoipContext } from '../../../components/GroChatVoipProvider/GroChatVoipProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import ButtonDarkBlue from '../../../components/Button/ButtonDarkBlue';
import ButtonBorderDarkBlue from '../../../components/Button/ButtonBorderDarkBlue';
import SimpleModal from '../../../components/SimpleModal/SimpleModal';
import ActionType from '../../../redux/reducer/globalActionType';

class Login extends Component {
    constructor(props) {
        super(props);
        this.tncTextRef = createRef()
        this.state = {
            isGrochatAuthenticated: false,
            authorization: '',
            code_verifier: '',
            token: '',
            detailUser: '',
            tnc: {
                tncText: '',
                tncVersion: '',
                resourceID: '',
                accepted: false,
            },
            tncModalOpen: false,
            hasScrolledTNC: false,
            isLocationSaved: false,
            location: {
                latitude: 0,
                longitude: 0
            }
        }
    }

    getGrochatInternalToken = data => {
        const popupWindow = (url, windowName, win, w, h) => {
            const y = win.top.outerHeight / 2 + win.top.screenY - h / 2;
            const x = win.top.outerWidth / 2 + win.top.screenX - w / 2;
            return win.open(
                url,
                windowName,
                `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${y}, left=${x}`
            );
        };

        API_AUTHENTICATION.getGrochatInternalToken()
            .then(res => {
                localStorage.setItem('requestId', Math.random().toString(36).substring(2));
                localStorage.setItem('token', this.state.token);

                let grochatUri = '';
                let token = getContent(res);
                let requestIdEncrypted = SHA256(localStorage.getItem('requestId'));
                let redirectUri = '';
                let resourceId = 'care';
                let cancelUri = '';
                let grochatBaseUrl = localUrl ? localUrl : baseUrl;

                if (data) {
                    grochatUri = `${grochatPwaUrl}/migrations`;
                    redirectUri = `${grochatBaseUrl}/grochat-migration?token=${this.state.token}`;
                    cancelUri = `${grochatBaseUrl}/grochat-cancel`;
                    let resourceName = 'NexCare';
                    let authUserId = data.user_id;
                    let username = data.username;
                    let userProfiling = 'C';

                    let linkMigrateUser = `${grochatUri}?token=${token}&request_id=${requestIdEncrypted}&success=${redirectUri}&resource_name=${resourceName}&resource_id=${resourceId}&cancel=${cancelUri}&auth_user_id=${authUserId}&userName=${username}&user_profiling=${userProfiling}`
                    return popupWindow(linkMigrateUser, '', window, 500, 700);
                }

                grochatUri = `${grochatPwaUrl}/login`;
                redirectUri = `${grochatBaseUrl}/grochat-login`;
                cancelUri = `${grochatBaseUrl}/grochat-cancel`;
                let linkRedirectUri = `${grochatUri}?token=${token}&request_id=${requestIdEncrypted}&redirect_uri=${redirectUri}&resource_id=${resourceId}&cancel=${cancelUri}`;
                return popupWindow(linkRedirectUri, '', window, 500, 700);
            }).catch(err => {
                console.log(err);
            })
    }

    postDataAuthorize = () => {
        API_AUTHENTICATION.postDataAuthorize()
            .then(async res => {
                if (this._isMounted) {
                    await this.setState({
                        authorization: res.headers.authorization,
                        code_verifier: res.headers['code_verifier']
                    });
                    this.postDataVerify();
                }
            }).catch(err => {
                this.setState({
                    showErrorConnect: true,
                    loading: false
                });
            })
    }

    handleAlreadyLogin = async () => {
        if (localStorage.getItem('isGrochatAuthenticated') === 'true') {
            const authentication = this.getAuthenticationFromPersist()
            if (authentication?.token && authentication?.userDetail) {
                this.props.handleLogin(
                    authentication.sign,
                    authentication.token,
                    authentication.internalToken,
                    authentication.refreshToken,
                    authentication.userDetail,
                    authentication.tncAccepted ?? false
                )
            }

            const tnc = await this.getTNC()
            if (!tnc || tnc.has_accepted) {
                this.props.handleUpdateTNCAcceptance(true)

                // User has accepted the Term and Conditions
                // OR there might be something wrong with fetching the Term and Conditions
                this.removeUsertoken()
                
                return redirectUri(this.getUserDetailFromPersist(), this.props.history)
            }

            // User has not accepted the Term and Conditions
            // Show the Term and Conditions on a modal box
            this.props.handleUpdateTNCAcceptance(false)
            this.showTNCModalBox(tnc)
        }
    }

    handleAccountMigration = () => {
        if (localStorage.getItem('isGrochatAccountMigrated')) {
            localStorage.removeItem('isGrochatAccountMigrated');
            this.setState({ showConfirmMigrationAlert: false });
            window.location.reload();
        }
    }

    async componentDidMount() {
        this._isMounted = true;

        // Get client location
        this.getCurrentLocation()
            .then(this.saveLocation)
            .catch(this.handleGeolocationNotSupportedErr)

        if (this.props.login || this.props.token !== null) {
            // Check if user has accepted TNC
            const tnc = await this.getTNC()
            if (tnc && !tnc.has_accepted) {
                // User has not accepted the TNC
                this.props.handleUpdateTNCAcceptance(false)
                this.showTNCModalBox(tnc)
            } else {
                // User has accepted the TNC
                this.props.handleUpdateTNCAcceptance(true)
                return redirectUri(this.props.userDetail, this.props.history);
            }
        }

        this.intervalLogin = setInterval(() => {
            this.handleAlreadyLogin();
        }, 1000);

        this.intervalMigration = setInterval(() => {
            this.handleAccountMigration();
        }, 1000);
    }

    componentWillUnmount() {
        this._isMounted = false;

        clearInterval(this.intervalLogin);
        clearInterval(this.intervalMigration);
    }

    getTNC = async () => {
        const token = this.getUsertoken()
        try {
            const result = await API_TNC.getTNC(token)
            return getContent(result)
        } catch(err) {
            return null
        }
    }

    showTNCModalBox = (tnc) => {
        clearInterval(this.intervalLogin)

        return this.setState({
            tnc: {
                ...this.state.tnc,
                tncText: tnc.tnc,
                tncVersion: tnc.tnc_version,
                resourceID: tnc.resource_id,
                accepted: false
            },
            tncModalOpen: true,
            hasScrolledTNC: false
        })
    }

    handleScrollTNC = () => {
        const tncTextRef = this.tncTextRef.current
        if (!tncTextRef) {
            return
        }

        const isBottom = Math.ceil(tncTextRef.scrollTop + tncTextRef.clientHeight) >= tncTextRef.scrollHeight
        if (isBottom) {
            this.setState({
                hasScrolledTNC: true
            })
        }
    }

    handleAcceptTNC = async () => {
        if (!this.state.hasScrolledTNC || !this.state.tnc.accepted || !this.state.isLocationSaved) {
            return
        }

        const data = {
            tnc_version: this.state.tnc.tncVersion,
            client_location: `${this.state.location.latitude}, ${this.state.location.longitude}`,
            os: navigator.userAgent,
        }

        const token = this.getUsertoken()

        try {
            await API_TNC.putAcceptTNC(data, token)

            this.props.handleUpdateTNCAcceptance(true)
            
            this.removeUsertoken()
            
            return redirectUri(this.getUserDetailFromPersist(), this.props.history);
        } catch(err) {
            alert("Gagal menyetujui TNC")
        }
    }

    handleCloseTNCModal = () => {
        const token = this.getUsertoken()

        API_AUTHENTICATION.postDataLogout(token)
        
        this.props.handleLogout()

        localStorage.removeItem('isGrochatAuthenticated')
        this.removeUsertoken()

        this.setState({
            tnc: {
                ...this.state.tnc,
                tncText: '',
                tncVersion: '',
                resourceID: '',
                accepted: false,
            },
            tncModalOpen: false,
            hasScrolledTNC: false
        })

        this.intervalLogin = setInterval(() => {
            this.handleAlreadyLogin();
        }, 1000);
    }

    saveLocation = (position) => {
        this.setState({
            isLocationSaved: true,
            location: {
                ...this.state.location,
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
            }
        })
    }

    handleGeolocationNotSupportedErr = (err) => {
        if (err.code === "GEOLOCATION_NOT_SUPPORTED") {
            return alert(err.message)
        }
    }

    getCurrentLocation = () => {
        return new Promise((resolve, reject) => {
            if (!navigator.geolocation) {
                const error = new Error("Geolocation tidak didukung browser");
                error.code = "GEOLOCATION_NOT_SUPPORTED";
                reject(error);
                return;
            }

            navigator.geolocation.getCurrentPosition(
                resolve,
                reject,
            );
        });
    };

    handleActivateLocation = () => {
        this.getCurrentLocation()
            .then(this.saveLocation)
            .catch(err => {
                this.handleGeolocationNotSupportedErr(err)
                if (err.code === 1) {
                    return alert("Izin lokasi telah ditolak. Silakan aktifkan kembali melalui pengaturan browser lalu refresh halaman.")
                }
                console.error("Location access err:", err)
            })
    }

    getUsertoken = () => {
        if (this.props.token) {
            return this.props.token
        }

        return localStorage.getItem("userToken")
    }

    removeUsertoken = () => {
        localStorage.removeItem("userToken")
    }

    getUserDetailFromPersist = () => {
        const authentication = this.getAuthenticationFromPersist()
        if (!authentication) {
            return null
        }

        return authentication.userDetail
    }

    getAuthenticationFromPersist = () => {
        const root = localStorage.getItem("persist:root")
        if (!root) {
            return null
        }

        const rootValue = JSON.parse(root)
        return JSON.parse(rootValue.authentication)
    }

    /**
     * @returns {React.ContextType<GroChatVoipContext>} 
     */
    getGroChatVoipContext = () => {
        return this.context;
    }

    render() {
        return (
            <div className="w-screen h-screen bg-white relative nexcare-login-background p-52">
                <OutsideLogo />
                <div className="flex items-center flex-row-reverse h-full text-center text-gray-600 ">
                    <div className="w-1/3 space-y-24">
                        <div>
                            <p className="font-bold" style={{ fontSize: "3.5rem" }}>Selamat Datang</p>
                            <div className="quote font-medium mt-5">
                                <p>Tim bukan sekelompok orang yang bekerja sama.</p>
                                <p>Tim adalah sekelompok orang yang saling percaya.</p>
                                <p>-Simon Sinek</p>
                            </div>
                        </div>
                        <div className="space-y-3">
                            <div className="font-medium text-lg">
                                <p>Gunakan Akun GroChat</p>
                                <p>untuk Mengakses Layanan NexCare</p>
                            </div>
                            <div className="flex justify-center">
                                <button type="button" id="btnlogingrochat" className="border-2 border-gray-300 rounded flex justify-center items-center space-x-2 py-2 px-5" onClick={() => this.getGrochatInternalToken()}>
                                    <IconGroChat />
                                    <span className="text-lg text-nexcarepurple2 font-medium">Masuk dengan Akun Grochat</span>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* TNC Modal */}
                <SimpleModal title='Syarat dan Ketentuan Terkait Data' isOpen={this.state.tncModalOpen} onClose={this.handleCloseTNCModal}>
                    <div 
                        className='mb-5 text-sm overflow-y-auto' 
                        style={{maxHeight: "600px"}} 
                        dangerouslySetInnerHTML={{ __html: this.state.tnc.tncText}}
                        ref={this.tncTextRef} 
                        onScroll={this.handleScrollTNC}
                    />
                    <div>
                        <div className='flex items-center mb-3 text-sm'>
                            <input 
                                id='agree' 
                                className='mr-2'
                                type='checkbox' 
                                checked={this.state.tnc.accepted} 
                                onChange={(e) => this.setState({ tnc: { ...this.state.tnc, accepted: e.target.checked } })}
                                disabled={!this.state.hasScrolledTNC} 
                            />
                            <label className={!this.state.hasScrolledTNC ? "text-gray-500" : ""} htmlFor='agree'>Dengan mencentang kotak ini, saya setuju dengan syarat dan ketentuan yang berlaku.</label>
                        </div>
                        {
                            !this.state.isLocationSaved 
                                && 
                            <span>
                                Aktifkan lokasi untuk melanjutkan. <span className='text-blue-600 border-b border-blue-600 cursor-pointer select-none' onClick={this.handleActivateLocation}>Aktifkan lokasi</span>
                            </span>
                        }
                        <div className='flex justify-end items-center'>
                            <ButtonBorderDarkBlue className="mr-3" onClick={this.handleCloseTNCModal}>Kembali</ButtonBorderDarkBlue>
                            <ButtonDarkBlue 
                                onClick={this.handleAcceptTNC} 
                                disabled={!this.state.hasScrolledTNC || !this.state.tnc.accepted || !this.state.isLocationSaved}
                            >
                                Setujui
                            </ButtonDarkBlue>
                        </div>
                    </div>
                </SimpleModal>
            </div>
        );
    }
}

Login.contextType = GroChatVoipContext;

const mapStateToProps = (state) => {
    return {
        login: state.authentication.login,
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogin: (sign, token, internalToken, refreshToken, userDetail, tncAccepted) => dispatch({
            type: ActionType.IS_LOGIN,
            payload: {
                sign,
                token,
                internalToken,
                refreshToken,
                userDetail,
                tncAccepted
            }
        }),
        handleUpdateTNCAcceptance: tncAccepted => dispatch({
            type: ActionType.UPDATE_TNC_ACCEPTANCE,
            payload: { tncAccepted }
        }),
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
